<template>
  <th v-if="isHeader">
    {{ title }}
  </th>
  <div v-else-if="rowData">
    <span class="f-s-14">
      <b>{{ getDay(rowData.request) }}</b> </span
    ><br />
  </div>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {request: {appointment: {day: '-'}}}
      },
    },
  },
  methods: {
    getDay: request => {
      return request && request.appointment ? request.appointment.day : ''
    },
  },
  name: 'Day',
}
</script>
<style src="@/styles/styled_cell.less" lang="less" scoped="true"></style>
